/* ============================================================
   ssp.js - Sensor Switch ride simulator (progressive enhancement)
   The section server-renders a correct static snapshot; this script
   makes the slider / PAS / mode controls live. No dependencies.
   ============================================================ */
(function () {
  "use strict";

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function initSim(root) {
    if (root.dataset.sspInit === "1") return;
    root.dataset.sspInit = "1";

    var els = {
      modeBtns: root.querySelectorAll("[data-mode]"),
      pasBtns: root.querySelectorAll("[data-pas]"),
      range: root.querySelector("[data-ssp-effort]"),
      effortVal: root.querySelector("[data-ssp-effort-val]"),
      pasVal: root.querySelector("[data-ssp-pas-val]"),
      hill: root.querySelector("[data-ssp-hill]"),
      fills: {
        effort: root.querySelector('[data-ssp-fill="effort"]'),
        torque: root.querySelector('[data-ssp-fill="torque"]'),
        cadence: root.querySelector('[data-ssp-fill="cadence"]')
      },
      vals: {
        effort: root.querySelector('[data-ssp-barval="effort"]'),
        torque: root.querySelector('[data-ssp-barval="torque"]'),
        cadence: root.querySelector('[data-ssp-barval="cadence"]')
      },
      barTorque: root.querySelector('[data-ssp-bar="torque"]'),
      barCadence: root.querySelector('[data-ssp-bar="cadence"]'),
      cadenceNote: root.querySelector("[data-ssp-cadence-note]"),
      takeaway: root.querySelector("[data-ssp-takeaway]")
    };
    if (!els.range) return;

    var state = {
      effort: parseInt(els.range.value, 10) || 45,
      pas: parseInt(root.getAttribute("data-pas-level"), 10) || 3,
      active: root.getAttribute("data-active") === "cadence" ? "cadence" : "torque",
      hilling: false,
      raf: 0
    };

    function compute() {
      var pasMult = state.pas / 5;
      var torque = Math.round(state.effort * (0.45 + 0.55 * pasMult));
      var cadence = state.effort > 4 ? Math.round(pasMult * 100) : 0;
      return { torque: torque, cadence: cadence };
    }

    function render() {
      var out = compute();
      // lane on root drives --ssp-lane (active button + dot color)
      root.classList.toggle("ssp-lane-torque", state.active === "torque");
      root.classList.toggle("ssp-lane-cadence", state.active === "cadence");
      root.setAttribute("data-active", state.active);

      // mode buttons
      Array.prototype.forEach.call(els.modeBtns, function (b) {
        var on = b.getAttribute("data-mode") === state.active;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      // pas buttons
      Array.prototype.forEach.call(els.pasBtns, function (b) {
        var on = parseInt(b.getAttribute("data-pas"), 10) === state.pas;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });

      if (els.effortVal) els.effortVal.textContent = state.effort + "%";
      if (els.pasVal) els.pasVal.textContent = String(state.pas);
      if (els.range && parseInt(els.range.value, 10) !== state.effort) els.range.value = state.effort;

      // bars
      if (els.fills.effort) els.fills.effort.style.height = Math.max(2, state.effort) + "%";
      if (els.fills.torque) els.fills.torque.style.height = Math.max(2, out.torque) + "%";
      if (els.fills.cadence) els.fills.cadence.style.height = Math.max(2, out.cadence) + "%";
      if (els.vals.effort) els.vals.effort.textContent = String(state.effort);
      if (els.vals.torque) els.vals.torque.textContent = String(out.torque);
      if (els.vals.cadence) els.vals.cadence.textContent = String(out.cadence);

      if (els.barTorque) els.barTorque.classList.toggle("is-dim", state.active !== "torque");
      if (els.barCadence) els.barCadence.classList.toggle("is-dim", state.active !== "cadence");
      if (els.cadenceNote) els.cadenceNote.textContent = "flat · PAS " + state.pas;

      if (els.takeaway) {
        els.takeaway.textContent = state.active === "torque"
          ? "Push harder, the motor gives more. Ease off, it backs down. Your legs set the pace."
          : "Locked at PAS " + state.pas + ". The motor holds the same assist no matter how hard you push.";
      }
    }

    function setEffort(v) { state.effort = clamp(parseInt(v, 10) || 0, 0, 100); render(); }

    els.range.addEventListener("input", function (e) {
      stopHill();
      setEffort(e.target.value);
    });
    Array.prototype.forEach.call(els.modeBtns, function (b) {
      b.addEventListener("click", function () { state.active = b.getAttribute("data-mode"); render(); });
    });
    Array.prototype.forEach.call(els.pasBtns, function (b) {
      b.addEventListener("click", function () { state.pas = parseInt(b.getAttribute("data-pas"), 10) || 3; render(); });
    });

    function stopHill() {
      if (state.raf) { cancelAnimationFrame(state.raf); state.raf = 0; }
      if (state.hilling) {
        state.hilling = false;
        if (els.hill) { els.hill.disabled = false; els.hill.textContent = "▲  Simulate a hill"; }
      }
    }
    if (els.hill) {
      els.hill.addEventListener("click", function () {
        if (state.hilling) return;
        state.hilling = true;
        els.hill.disabled = true;
        els.hill.textContent = "Climbing…";
        var v = state.effort;
        var tick = function () {
          v = Math.min(92, v + 2.5);
          setEffort(Math.round(v));
          if (v < 92) { state.raf = requestAnimationFrame(tick); }
          else { stopHill(); }
        };
        state.raf = requestAnimationFrame(tick);
      });
    }

    render();
  }

  function boot() {
    var sims = document.querySelectorAll("[data-ssp-sim]");
    Array.prototype.forEach.call(sims, initSim);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
